module.exports = {
  "title": "compose",
  "placeholder": "Enter subject",
  "template_placeholder": "Type here to search",
  "tooltip": "This email will be sent from share@paperflite.email. Please connect your Outlook/Gmail/Email account to send from your email.",
  "to": "To",
  "cc": "Cc",
  "bcc": "Bcc",
  "subject": "Subject",
  "bulk_email_tooltip": "This feature lets you send content as individual emails to each recipient. Turn this OFF to send as an email with all recipients visible in the “To” field.",
  "send_as_individual": "Send as individual emails",
  "allow_recipients": "Allow recipients to",
  "actions": {
    "select_template": "Select Template",
    "insert_widget": "Select a Widget",
    "configure_here": "Configure here",
    "attach_documents": "Attach <br /> Documents",
    "advanced_settings": "Advanced Settings",
    "send": "Send",
    "sending": "Sending",
    "attach_assets": "Attach Assets"
  },
  "toast": {
    "message": "Assets will be replaced",
    "description": "Selecting a template will replace the existing assets in your email with assets used in the template. Continue?",
    "actions": {
      "yes": "Yes",
      "no": "No"
    }
  },
  "default_message": {
    "compose": {
      "title": "Hello there,",
      "description": "Here's a collection of assets exclusively personalized for you! Hope you find this material useful.",
      "sub_text": "I'd love to hear what you think about them. Please feel free to get in touch at any time.",
      "signature": "Signature"
    },
    "asset": {
      "no_asset": "No Asset",
      "assets": "Assets you add will be shown here."
    },
    "asset_table": {
      "title": "Asset Table",
      "description": "The content assets you add to this email will be displayed here."
    },
    "collection_detail": "Click here for your personal copy of {count} documents with reference to our discussion. Hope you will find them useful.",

    "footer_message": {
      "title": "Hello there,",
      "sub_text": "Hope this mail finds you well.",
      "description": "Here's a collection of interesting content pieces that I'd like to share with you. This was built using Paperflite.",
      "sub_title": " Hope you find them useful.",
      "thank_you": "Thank you!",
      "footer": {
        "title": "You received this mail because the person (It is a real person and certainly not a bot, believe us) who sent this to you was looking at a Collection (microsite of sorts - its quite simple really) of content pieces hand-crafted using Paperflite.",
        "sub_text": "PS (Sorry to bring the PS so early): If you&rsquo;d like to build a Collection like this in a matter of minutes (we were so tempted to type seconds instead of minutes because it is true - but, decided that it might be a bit much of advertisement - so, stuck our guns to minutes despite too much of pressure from our product marketing team).Anyway, to recap - you can build some amazing landing pages, interactive content and a lot more using Paperflite. All you have to do it ask us how.",
        "subscribe": "One last thing, if you&rsquo;d like to subscribe to our Newsletter, please click here",
        "rights_reserved": "2022 Paperflite, All Rights Reserved.",
        "contact_us": "Contact Us",
        "privacy_policy": "View our Privacy Policy",
        "address": "Registered: Paperflite, 341 Raven Circle, Camden, Wyoming, DE 19934, United States"
      }
    }
  },
  "empty_message": {
    "assets": {
      "title": "This space is vacant / available / to let",
      "description": "No assets added yet. Click the big + to add them from your collections, or just drag & drop them in from your device."
    },
    "email_template": {
      "title": "Let's make this easier for everyone",
      "description": "Create reusable templates for you and your team.",
      "actions": {
        "create_new": "Create New"
      }
    }
  },
  "recommended_assets": {
    "title": "Recommended Assets",
    "loading": "Fetching Recommendations",
    "description": "These are the assets that are most likely to be relevant to your email.",
    "tooltip": "Based on your share patterns"
  },
  "error_messages": {
    "invalid_emails": "One or more emails are invalid, Please check!",
    "dnd": "Psst! One or more recipients have enabled DND and will not receive your email.",
    "email_disabled": "You cannot send emails via Paperflite. Please contact your administrator!"
  }
}